import { render, staticRenderFns } from "./ApplicationTableCustomField.vue?vue&type=template&id=06e67e30"
import script from "./ApplicationTableCustomField.vue?vue&type=script&lang=js"
export * from "./ApplicationTableCustomField.vue?vue&type=script&lang=js"
import style0 from "./ApplicationTableCustomField.vue?vue&type=style&index=0&id=06e67e30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports